export default "__VITE_ASSET__DFBiSiju__"